<template>
  <button
    v-if="isPermitted"
    type="button"
    :class="[
      'flex justify-center border bg-white text-sm leading-5 font-medium hover:bg-white hover:shadow hover:border-white focus:outline-none transition ease-in-out duration-150 focus:ring-2 disabled:cursor-default',
    ]"
    v-bind="$attrs"
    v-on="$listeners"
    :disabled="disabled || $attrs.loading"
    v-tooltip.top="tooltip"
  >
    <div :class="['relative flex items-center justify-center h-full', size]">
      <base-icon
        :icon="icon"
        :class="[font, , 'items-center', $attrs.loading ? 'animate-spin' : '']"
      />
    </div>
  </button>
</template>

<script>
import BaseIcon from './_base-icon.vue'
import {iconStyle} from '@/state/helpers/mixins.js'
import {icons} from '@/state/helpers/buttons.js'

export default {
  components: {BaseIcon},
  // Provides size, font
  mixins: [iconStyle],
  props: {
    action: {
      default: '',
    },
  },
  created() {
    if (typeof icons[this.action] !== 'undefined') {
      this.isPermitted = this.$store.getters['auth/isPermitted'](icons[this.action].permission)
      this.iconTooltip = icons[this.action].tooltip
    }
  },
  data() {
    return {
      isPermitted: true,
      iconTooltip: this.$attrs.icon,
    }
  },
  computed: {
    disabled() {
      return this.$attrs.loading || this.$attrs.disabled
    },
    tooltip() {
      return this.getTranslation
    },
    getTranslation() {
      const tooltipText =
        typeof this.$attrs.tooltip !== 'undefined' ? this.$attrs.tooltip : this.iconTooltip
      return this.$te(`mygwf.components.ButtonIcon.${tooltipText}`)
        ? this.$t(`mygwf.components.ButtonIcon.${tooltipText}`)
        : tooltipText
    },
    icon() {
      return this.$attrs.loading
        ? 'spinner-btn'
        : typeof this.$attrs.icon !== 'undefined'
        ? this.$attrs.icon
        : icons[this.action].icon
    },
  },
}
</script>

<style scoped></style>
